<template>
  <div class="container o-form-page">
    <o-section :title="title" @click="enableDebug($event)" :level="0">
      <item-form></item-form>
    </o-section>
  </div>
</template>

<script>
import ItemForm from "../components/ItemForm.vue";
import OSection from "../../../vue-ocom/components/layout/OSection";

export default {
  mixins: [],
  components: {
    OSection,
    ItemForm,
  },
  computed: {
    title() {
      return "Generate QR Code";
    },
  },
};
</script>
